<template>
<div class="chapter">
<div class="inner_page">
<div class="box">
<p class="boxp">Front cover. Top: Front three-quarter view of the Amalgam Collection E-Type Roadster 1/8 scale. Centre photos clockwise from top left: E-Type V12 S3 Coupe with longer wheelbase defined a different E-Type for the 1970s; The essential S1 soft-top E-Type in all its ellipsoid elegance; The S1 fastback Coupe and S2 Roadster show off their different designs. Profile: E-Type Roadster in red (David Bocquelet).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Fm02.vue?7049b5c4